module.exports = __webpack_public_path__ + "static/azure-native-vms-3-6bd63f0f57b7417ee7ee2822a20633f6.png";